var map = {
	"./add.svg": "5110",
	"./danger.svg": "2b5b",
	"./delete.svg": "a3dd",
	"./jiantoubottom.svg": "cd22",
	"./jiantouyou.svg": "a4d1",
	"./jiantouzuo.svg": "bc44",
	"./pageyou.svg": "bc0d",
	"./pagezuo.svg": "fdac",
	"./rendui.svg": "c4a2",
	"./security.svg": "f901",
	"./uploud.svg": "34f0",
	"./wenjian.svg": "3894",
	"./wenjianwujiaoxing.svg": "ca39"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "23f1";